/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OnboardingStatusEnum } from './OnboardingStatusEnum';
import {
    OnboardingStatusEnumFromJSON,
    OnboardingStatusEnumFromJSONTyped,
    OnboardingStatusEnumToJSON,
    OnboardingStatusEnumToJSONTyped,
} from './OnboardingStatusEnum';
import type { Invitation } from './Invitation';
import {
    InvitationFromJSON,
    InvitationFromJSONTyped,
    InvitationToJSON,
    InvitationToJSONTyped,
} from './Invitation';
import type { Membership } from './Membership';
import {
    MembershipFromJSON,
    MembershipFromJSONTyped,
    MembershipToJSON,
    MembershipToJSONTyped,
} from './Membership';
import type { TeamFeatures } from './TeamFeatures';
import {
    TeamFeaturesFromJSON,
    TeamFeaturesFromJSONTyped,
    TeamFeaturesToJSON,
    TeamFeaturesToJSONTyped,
} from './TeamFeatures';
import type { SubscriptionTypeEnum } from './SubscriptionTypeEnum';
import {
    SubscriptionTypeEnumFromJSON,
    SubscriptionTypeEnumFromJSONTyped,
    SubscriptionTypeEnumToJSON,
    SubscriptionTypeEnumToJSONTyped,
} from './SubscriptionTypeEnum';

/**
 * 
 * @export
 * @interface Team
 */
export interface Team {
    /**
     * 
     * @type {number}
     * @memberof Team
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    slug?: string;
    /**
     * 
     * @type {Array<Membership>}
     * @memberof Team
     */
    readonly members: Array<Membership>;
    /**
     * 
     * @type {Array<Invitation>}
     * @memberof Team
     */
    readonly invitations: Array<Invitation>;
    /**
     * 
     * @type {string}
     * @memberof Team
     */
    readonly dashboardUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof Team
     */
    readonly isAdmin: boolean;
    /**
     * Current status of team onboarding process
     * 
     * * `not_started` - Not Started
     * * `in_progress` - In Progress
     * * `completed` - Completed
     * * `expired` - Expired
     * @type {OnboardingStatusEnum}
     * @memberof Team
     */
    readonly onboardingStatus: OnboardingStatusEnum;
    /**
     * 
     * @type {SubscriptionTypeEnum}
     * @memberof Team
     */
    readonly subscriptionType: SubscriptionTypeEnum;
    /**
     * Credits available for monitoring domains for stealer leaks
     * @type {number}
     * @memberof Team
     */
    readonly stealerLeaksCredits: number;
    /**
     * 
     * @type {TeamFeatures}
     * @memberof Team
     */
    readonly features: TeamFeatures;
}



/**
 * Check if a given object implements the Team interface.
 */
export function instanceOfTeam(value: object): value is Team {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('invitations' in value) || value['invitations'] === undefined) return false;
    if (!('dashboardUrl' in value) || value['dashboardUrl'] === undefined) return false;
    if (!('isAdmin' in value) || value['isAdmin'] === undefined) return false;
    if (!('onboardingStatus' in value) || value['onboardingStatus'] === undefined) return false;
    if (!('subscriptionType' in value) || value['subscriptionType'] === undefined) return false;
    if (!('stealerLeaksCredits' in value) || value['stealerLeaksCredits'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    return true;
}

export function TeamFromJSON(json: any): Team {
    return TeamFromJSONTyped(json, false);
}

export function TeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): Team {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'members': ((json['members'] as Array<any>).map(MembershipFromJSON)),
        'invitations': ((json['invitations'] as Array<any>).map(InvitationFromJSON)),
        'dashboardUrl': json['dashboard_url'],
        'isAdmin': json['is_admin'],
        'onboardingStatus': OnboardingStatusEnumFromJSON(json['onboarding_status']),
        'subscriptionType': SubscriptionTypeEnumFromJSON(json['subscription_type']),
        'stealerLeaksCredits': json['stealer_leaks_credits'],
        'features': TeamFeaturesFromJSON(json['features']),
    };
}

  export function TeamToJSON(json: any): Team {
      return TeamToJSONTyped(json, false);
  }

  export function TeamToJSONTyped(value?: Omit<Team, 'id'|'name'|'members'|'invitations'|'dashboard_url'|'is_admin'|'onboarding_status'|'subscription_type'|'stealer_leaks_credits'|'features'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
    };
}

